import { Text } from '@kanda-libs/ks-design-library';
import { useFinanceOptionsContext } from 'components/FinanceOptions/context';
import type { GroupedByKey } from 'utils';
import Rate from './Rate';
import useOption from './useOption';

export interface OptionProps {
  apr: string;
  rates: GroupedByKey;
  toggleable: boolean;
}

const Option: React.FunctionComponent<OptionProps> = function ({
  apr,
  rates,
  toggleable,
}) {
  const { title, keys } = useOption(apr, rates);
  const { isLoading } = useFinanceOptionsContext();
  return (
    <div className="grid grid-cols-[1fr_90px_90px] gap-y-1 md:gap-y-3 gap-x-1">
      <Text
        className="text-11-20-em-up text-neutral-600 min-w-[60px]"
        isLoading={isLoading}
        text={title}
      />
      <Text
        className="text-11-20-em-up text-neutral-600"
        isLoading={isLoading}
        text="from"
      />
      <Text
        className="text-11-20-em-up text-neutral-600"
        isLoading={isLoading}
        text="subsidy"
      />
      {keys.map((key) => (
        <Rate key={key} rates={rates[key]} toggleable={toggleable} />
      ))}
    </div>
  );
};

export default Option;
